module.exports = __webpack_public_path__ + "assets/handle-tip-1eda4c6c.png";